import { useSyncExternalStore } from 'react'

export type TDeviceType = 'pc' | 'pad' | 'phone'

const subscribe = (callback: () => void) => {
  window.addEventListener('resize', callback)
  return () => window.removeEventListener('resize', callback)
}

const getSnapshot = () => {
  if (typeof window === 'undefined') return 'pc'
  const width = window.innerWidth
  return width > 1024 ? 'pc' : width > 768 ? 'pad' : 'phone'
}

const getServerSnapshot = (): TDeviceType => 'pc' // 服务器端的默认值

// 使用该 hook 时，仅仅当无法用scss中的 media query 实现时，才使用该 hook。
// 避免滥用此钩子。css能做到的事情避免用js实现。
export function useResponsiveDevice() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
